import React, { useState } from "react";
import DashboardHeader from "../../Header/DashboardHeader";
import DashboardFooter from "../../Footer/DashboardFooter";
import DashboardLeftMenu from "../DashboardLeftMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSearch, faServer, faExternalLinkAlt, faDownload,
} from "@fortawesome/free-solid-svg-icons";

/* ── logo imports ── */
import zapierImg       from '../assets/img/zapier image-Photoroom.png';
import pabblyImg       from '../assets/img/Adobe Express - file.png';
import integratelyImg  from '../assets/img/images-removebg-preview.png';
import meetanshiImg    from '../assets/img/meetanshi_logo-removebg-preview.png';
import kylasImg        from '../assets/img/kylas-sales-crm-removebg-preview.png';
import shopifyImg      from '../assets/img/199-1995584_shopify-shopify-logo-png-removebg-preview.png';
import moengageImg     from '../assets/img/moengage_logo_a1b5ee3fe6-removebg-preview.png';
import pinelabsImg     from '../assets/img/images__1_-removebg-preview.png';
import eazyrewardImg   from '../assets/img/Easyrewardz-Logo-removebg-preview.png';
import unicommerceImg  from '../assets/img/unicommerce-removebg-preview.png';
import clevertapImg    from '../assets/img/CleverTap_fav-removebg-preview.png';
import ginesysImg    from '../assets/img/Ginesys_SQ_Logo-removebg-preview.png';

/* ── category meta ── */
const CAT = {
    'Automation':  { border: '#06b6d4', text: '#0891b2', bg: '#e0f2fe' },
    'Marketing':   { border: '#ef4444', text: '#dc2626', bg: '#fee2e2' },
    'CRM & Sales': { border: '#3b82f6', text: '#2563eb', bg: '#dbeafe' },
    'E-Commerce':  { border: '#22c55e', text: '#16a34a', bg: '#dcfce7' },
};

/* ── integrations data ── */
const INTEGRATIONS = [
    {
        id: 1, name: 'Zapier', category: 'Automation',
        description: 'Connect your auth keys to 5,000+ apps to automate workflows.',
        img: zapierImg,
        detailsUrl: '#', configureUrl: '#',
    },
    {
        id: 2, name: 'Pabbly Connect', category: 'Automation',
        description: 'Integrate workspace workflows and auth configurations with Pabbly.',
        img: pabblyImg,
        detailsUrl: 'https://authkey.io/blogs/integrate-authkey-with-pabbly-connect/',
        configureUrl: 'https://payments.pabbly.com/api/affurl/RVYZ07kQyUZ0Z1HUKZ1m/91jvhKKkKc0Phnfp?target=9Z2AHyhSldo6KI1Fn',
    },
    {
        id: 3, name: 'Integrately', category: 'Automation',
        description: 'Activate 1-click automations for your app with Integrately.',
        img: integratelyImg,
        detailsUrl: 'https://authkey.io/blogs/authkey-integrations-with-integrately/',
        configureUrl: 'https://integrately.com/integrations/authkey',
    },
    {
        id: 4, name: 'Meetanshi', category: 'Marketing',
        description: 'Synchronize validation and transaction structures for Magento through Meetanshi modules.',
        img: meetanshiImg,
        detailsUrl: '#', configureUrl: '#',
    },
    {
        id: 5, name: 'Kylas CRM', category: 'CRM & Sales',
        description: 'Streamline lead and user validation credentials into Kylas sales pipelines.',
        img: kylasImg,
        detailsUrl: '#', configureUrl: '#',
    },
    {
        id: 6, name: 'Ginesys', category: 'Marketing',
        description: 'Advanced communication and routing solutions powered by Genisys systems.',
        img: ginesysImg,
        detailsUrl: '#', configureUrl: '#',
    },
    {
        id: 7, name: 'Shopify', category: 'E-Commerce',
        description: 'Secure your e-commerce storefront API accesses and webhook key rotations.',
        img: shopifyImg,
        detailsUrl: '#', configureUrl: '#',
    },
    {
        id: 8, name: 'MoEngage', category: 'Marketing',
        description: 'Map user authentication statuses to customized MoEngage profiles.',
        img: moengageImg,
        detailsUrl: '#', configureUrl: '#',
    },
    {
        id: 9, name: 'Pine Labs', category: 'E-Commerce',
        description: 'Authorize and validate smart terminal POS sessions and payment status tokens.',
        img: pinelabsImg,
        detailsUrl: '#', configureUrl: '#',
    },
    {
        id: 10, name: 'EazyReward', category: 'Marketing',
        description: 'Send reward notifications and OTPs to customers via Authkey messaging channels.',
        img: eazyrewardImg,
        detailsUrl: '#', configureUrl: '#',
    },
    {
        id: 11, name: 'Unicommerce', category: 'E-Commerce',
        description: 'Automate order and shipment notifications across Unicommerce fulfillment workflows.',
        img: unicommerceImg,
        detailsUrl: '#', configureUrl: '#',
    },
    {
        id: 12, name: 'CleverTap', category: 'Marketing',
        description: 'Trigger CleverTap campaigns and push notifications through Authkey messaging events.',
        img: clevertapImg,
        detailsUrl: '#', configureUrl: '#',
    },
];

/* ── component ── */
const MarketPlace = () => {
    const [search, setSearch] = useState('');
    const [selectedCat, setSelectedCat] = useState('');

    const categories = ['All', ...Object.keys(CAT)];

    const filtered = INTEGRATIONS.filter(item => {
        const q = search.toLowerCase();
        const matchSearch = item.name.toLowerCase().includes(q) || item.description.toLowerCase().includes(q);
        const matchCat = !selectedCat || selectedCat === 'All' || item.category === selectedCat;
        return matchSearch && matchCat;
    });

    return (
        <div className="wrapper">
            <DashboardLeftMenu />
            <div className="main">
                <DashboardHeader />
                <main className="content">
                    <div className="container-fluid p-0">

                        {/* Page heading */}
                        <div style={{ marginBottom: '6px' }}>
                            <h4 style={{ fontWeight: '700', color: '#1e293b', margin: 0 }}>
                                Marketplace
                            </h4>
                            <p style={{ fontSize: '13px', color: '#64748b', margin: '4px 0 0' }}>
                                ⁠Solution that support authkey native integration
                            </p>
                        </div>

                        <hr style={{ margin: '14px 0 20px' }} />

                        {/* ── Search + Filter ── */}
                        <div style={{ display: 'flex', gap: '12px', marginBottom: '24px', flexWrap: 'wrap' }}>
                            {/* Search */}
                            <div style={{ flex: 1, minWidth: '220px', position: 'relative' }}>
                                <FontAwesomeIcon
                                    icon={faSearch}
                                    style={{ position: 'absolute', left: '13px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8', fontSize: '13px', pointerEvents: 'none' }}
                                />
                                <input
                                    type="text"
                                    placeholder="Search integrations by name or keyword..."
                                    value={search}
                                    onChange={e => setSearch(e.target.value)}
                                    style={{
                                        width: '100%', height: '42px',
                                        paddingLeft: '38px', paddingRight: '14px',
                                        border: '1px solid #e2e8f0', borderRadius: '10px',
                                        fontSize: '13px', color: '#374151', outline: 'none',
                                        background: '#fff', boxSizing: 'border-box',
                                    }}
                                />
                            </div>
                            {/* Category filter */}
                            <select
                                value={selectedCat}
                                onChange={e => setSelectedCat(e.target.value)}
                                style={{
                                    height: '42px', border: '1px solid #e2e8f0', borderRadius: '10px',
                                    padding: '0 14px', fontSize: '13px', color: '#374151',
                                    minWidth: '170px', outline: 'none', cursor: 'pointer',
                                    background: '#fff', flexShrink: 0,
                                }}
                            >
                                {categories.map(c => (
                                    <option key={c} value={c === 'All' ? '' : c}>{c}</option>
                                ))}
                            </select>
                        </div>

                        {/* ── Cards grid ── */}
                        {filtered.length === 0 ? (
                            <div style={{ textAlign: 'center', padding: '60px 0', color: '#94a3b8' }}>
                                <p style={{ fontSize: '14px' }}>No integrations match your search.</p>
                            </div>
                        ) : (
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                                gap: '20px',
                            }}>
                                {filtered.map(item => {
                                    const cat = CAT[item.category] || { border: '#94a3b8', text: '#64748b', bg: '#f1f5f9' };
                                    return (
                                        <div
                                            key={item.id}
                                            style={{
                                                background: '#fff',
                                                borderRadius: '12px',
                                                border: '1px solid #e8e8f0',
                                                borderTop: `3px solid ${cat.border}`,
                                                boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                                                display: 'flex', flexDirection: 'column',
                                                padding: '18px 20px',
                                                transition: 'box-shadow 0.2s, transform 0.15s',
                                                fontFamily: 'Inter, system-ui, sans-serif',
                                                cursor: 'default',
                                            }}
                                            onMouseEnter={e => {
                                                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.11)';
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                            }}
                                            onMouseLeave={e => {
                                                e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.06)';
                                                e.currentTarget.style.transform = 'translateY(0)';
                                            }}
                                        >
                                            {/* Top row: icon + badge */}
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '14px' }}>
                                                <div style={{
                                                    width: '46px', height: '46px', borderRadius: '12px',
                                                    background: item.img ? '#f8fafc' : item.iconBg,
                                                    border: item.img ? '1px solid #e2e8f0' : 'none',
                                                    display: 'flex',
                                                    alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                                                    overflow: 'hidden',
                                                }}>
                                                    {item.img ? (
                                                        <img
                                                            src={item.img}
                                                            alt={item.name}
                                                            style={{ width: '34px', height: '34px', objectFit: 'contain' }}
                                                        />
                                                    ) : (
                                                        <FontAwesomeIcon icon={item.icon} style={{ color: '#fff', fontSize: '19px' }} />
                                                    )}
                                                </div>
                                                <div style={{ textAlign: 'right' }}>
                                                    <div style={{ fontSize: '10px', fontWeight: '700', color: '#94a3b8', letterSpacing: '0.6px', marginBottom: '5px' }}>
                                                        AVAILABLE
                                                    </div>
                                                    <span style={{
                                                        fontSize: '10px', fontWeight: '600',
                                                        padding: '2px 9px', borderRadius: '5px',
                                                        background: cat.bg, color: cat.text,
                                                        whiteSpace: 'nowrap',
                                                    }}>
                                                        {item.category}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Name */}
                                            <h6 style={{ margin: '0 0 7px', fontWeight: '700', color: '#1e293b', fontSize: '15px', lineHeight: '1.3' }}>
                                                {item.name}
                                            </h6>

                                            {/* Description */}
                                            <p style={{ fontSize: '12px', color: '#64748b', lineHeight: '1.65', margin: 0, flex: 1 }}>
                                                {item.description}
                                            </p>

                                            {/* Footer */}
                                            {/* <div style={{
                                                display: 'flex', alignItems: 'center',
                                                justifyContent: 'space-between',
                                                marginTop: '18px', paddingTop: '14px',
                                                borderTop: '1px solid #f1f5f9',
                                            }}>
                                                <a
                                                    href={item.detailsUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ fontSize: '12px', color: '#94a3b8', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px' }}
                                                    onMouseEnter={e => e.currentTarget.style.color = '#6366f1'}
                                                    onMouseLeave={e => e.currentTarget.style.color = '#94a3b8'}
                                                >
                                                    Details <FontAwesomeIcon icon={faExternalLinkAlt} style={{ fontSize: '9px' }} />
                                                </a>
                                                <a
                                                    href={item.configureUrl}
                                                    target={item.isDownload ? '_self' : '_blank'}
                                                    rel="noopener noreferrer"
                                                    download={item.isDownload || undefined}
                                                    style={{
                                                        padding: '7px 18px', borderRadius: '8px',
                                                        background: '#6366f1', color: '#fff',
                                                        fontSize: '12px', fontWeight: '600',
                                                        textDecoration: 'none',
                                                        display: 'inline-flex', alignItems: 'center', gap: '6px',
                                                        transition: 'background 0.2s',
                                                    }}
                                                    onMouseEnter={e => e.currentTarget.style.background = '#4f46e5'}
                                                    onMouseLeave={e => e.currentTarget.style.background = '#6366f1'}
                                                >
                                                    {item.isDownload
                                                        ? <><FontAwesomeIcon icon={faDownload} style={{ fontSize: '11px' }} /> Download</>
                                                        : 'Configure'}
                                                </a>
                                            </div> */}
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                    </div>
                </main>
                <DashboardFooter />
            </div>
        </div>
    );
};

export default MarketPlace;
